export default __webpack_public_path__ + "static/media/BLR2.07c396d1.jpg";